// extracted by mini-css-extract-plugin
module.exports = {"root":"_271d06","logo":"_77fee8","title":"_14a379","info":"_18424b","ratedTag":"_fdb286"};